import styled from "styled-components";
import { nanoid } from "nanoid";
import { ChangeEvent } from "react";
import { AddRounded } from "@mui/icons-material";

interface ImagePickerProps {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value: File | undefined;
  placeholder: string;
  default?: string;
}

const Placeholder = styled.div`
  text-align: center;
  margin: 0.5rem 0;
  font-weight: bold;
`;

const Input = styled.input`
  display: none;
`;
const Label = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 12px;
  cursor: pointer;
`;

const ImagePickerStyle = styled.div`
  position: relative;
  overflow: hidden;
  height: 150px;
  width: 150px;
  cursor: pointer;
  border-radius: 12px;
  background: #eeeeee;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cccccc;
  font-size: 4rem;
  transition: 0.1s;
  &:hover {
    color: #bbbbbb;
  }
  img {
    height: 100%;
    width: 100%;
  }
`;

function PreviewImage(props: { file: File }) {
  return <img src={URL.createObjectURL(props.file)} alt="Preview" />;
}

function Image(props: { default: string }) {
  return <img src={props.default} alt="Preview" />;
}

export default function ImagePicker(props: ImagePickerProps) {
  const id = nanoid(6);
  return (
    <>
      <div>
        <ImagePickerStyle>
          {!props.value &&
            (!!props.default ? (
              <Image default={props.default} />
            ) : (
              <AddRounded />
            ))}
          {props.value && <PreviewImage file={props.value} />}
          <Input
            type="file"
            id={`file-input-${id}`}
            onChange={props.onChange}
            accept={"image/*"}
          />
          <Label htmlFor={`file-input-${id}`} />
        </ImagePickerStyle>
        <Placeholder>{props.placeholder}</Placeholder>
      </div>
    </>
  );
}
